import { useState } from 'react'
import { PopupModal } from 'react-calendly'
import { Button } from '@mui/material'
import CallIcon from '@mui/icons-material/Call'

export default function CalendlyPopup() {
  const [open, setOpen] = useState(false)

  return (
    <>
      <Button
        size='small'
        variant='contained'
        sx={{
          backgroundColor: 'primary.main',
          '&:hover': {
            backgroundColor: 'primary.dark',
          },
        }}
        onClick={() => setOpen(true)}
      >
        <CallIcon fontSize='small' sx={{ mr: 1 }} />
        Live Help
      </Button>

      <PopupModal
        url='https://calendly.com/dw-j'
        onModalClose={() => setOpen(false)}
        open={open}
        rootElement={document.getElementById('root') as HTMLElement}
      />
    </>
  )
}
